import { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { useGameStore } from '../../core/store';
import { play } from '../audio';

/**
 * Claim = "Step into the tunnel"
 * Solid jersey → slow dissolve into dust → empty hanger (hook stays) → black.
 */
export function LockerClaimBeat() {
  const beat = useGameStore((s) => s.lockerBeat);
  const setOverlayOpacity = useGameStore((s) => s.setOverlayOpacity);
  const finishLockerClaim = useGameStore((s) => s.finishLockerClaim);
  const setLockerClaimTouched = useGameStore((s) => s.setLockerClaimTouched);
  const setLockerDissolve = useGameStore((s) => s.setLockerDissolve);
  const setLockerCine = useGameStore((s) => s.setLockerCine);
  const ran = useRef(false);

  useEffect(() => {
    if (beat !== 'claim') {
      if (beat === 'cinematic' || beat === 'identity') {
        ran.current = false;
        setLockerDissolve(0);
        setLockerClaimTouched(false);
      }
      return;
    }

    if (ran.current) return;
    ran.current = true;

    setOverlayOpacity(0);
    setLockerClaimTouched(false);
    setLockerDissolve(0);
    setLockerCine({
      on: false,
      wash: 1,
      spot: 1,
      flicker: 1,
      flash: 0,
      particles: false,
    });

    const proxy = { d: 0 };
    const overlay = { o: 0 };
    const tl = gsap.timeline();

    // Solid hold, then a slow peel into dust
    tl.to({}, { duration: 0.7 });

    tl.add(() => {
      void play('silence', { gain: 0.1 });
    });

    // Slow rising dissolve — hem → shoulders
    tl.to(proxy, {
      d: 1,
      duration: 7.2,
      ease: 'sine.inOut',
      onUpdate: () => setLockerDissolve(proxy.d),
    });

    tl.add(() => {
      setLockerDissolve(1);
      setLockerClaimTouched(true);
      void play('silence', { gain: 0.16 });
    });
    tl.to({}, { duration: 0.55 });

    tl.to(overlay, {
      o: 1,
      duration: 0.5,
      ease: 'power2.in',
      onUpdate: () => setOverlayOpacity(overlay.o),
    });
    tl.add(() => {
      finishLockerClaim();
    });

    return () => {
      tl.kill();
    };
  }, [
    beat,
    finishLockerClaim,
    setOverlayOpacity,
    setLockerClaimTouched,
    setLockerDissolve,
    setLockerCine,
  ]);

  return null;
}
